import {
  FormValidationBooleanSchema,
  FormValidationNumberSchema,
  FormValidationObjectSchema,
  FormValidationStringSchema,
} from '../typings';
import { SchemaFactory } from '../core';

export class FormValidationSchemaBuilder {
  private constructor() {
    // private constructor
  }

  public static string(): FormValidationStringSchema {
    return SchemaFactory.string();
  }

  public static number(): FormValidationNumberSchema {
    return SchemaFactory.number();
  }

  public static boolean(): FormValidationBooleanSchema {
    return SchemaFactory.boolean();
  }

  public static object(): FormValidationObjectSchema {
    return SchemaFactory.object();
  }
}
